import backend from "./backend";

export const getProducts = (
  dynamicsId,
  pageNumber,
  pageSize,
  searchTerm,
  Categoria,
  Rubro,
  SubRubro,
  promocion
) => {
  promocion = promocion === "LANZAMIENTOS" ? "LANZAMIENT" : promocion;

  const params = new URLSearchParams({
    pageNumber,
    pageSize,
    searchTerm,
    Categoria,
    Rubro,
    SubRubro,
    promocion,
  });

  return backend.get(`product/customer/${dynamicsId}?${params.toString()}`);
};

export const getProduct = (productId, dynamicsId) => {
  return backend.get(
    `product/${encodeURIComponent(productId)}/customer/${dynamicsId}`
  );
};

export const getPresentaciones = (productId) => {
  return backend.get(`product/presentaciones/${encodeURIComponent(productId)}`);
};

export const getDescuento = (productId, customerId, qty) => {
  return backend.get(
    `product/${encodeURIComponent(
      productId
    )}/descuento/customer/${customerId}/qty/${qty}`
  );
};
export const getValidarCarga = (productId, qty) => {
  return backend.get(
    `product/${encodeURIComponent(productId)}/validate/qty/${qty}`
  );
};

export const getTipologias = (priceLevel) => {
  return backend.get(
    `product/categorias?priceLevel=${encodeURIComponent(priceLevel)}`
  );
};
export const getAlicuota = (dynamicsId) => {
  return backend.get(`/customer/${dynamicsId}/alicuota`);
};
export const getCustomer = (customerNumber) => {
  return backend.get(`customer/${customerNumber}`);
};

export const getCustomerAddresses = (customerId) => {
  return backend.get(`customer/${customerId}/addresses`);
};

export const getCustomersBySalesPerson = (sellerId, searchTerm) => {
  return backend.get(
    `customer?salesPersonId=${sellerId}&searchTerm=${searchTerm}`
  );
};

export const postOrder = (formData) => {
  return backend.post("weborder/checkout", formData);
};

export const getWebOrders = (status) => {
  const params = new URLSearchParams(status.map((x) => ["status", x]));

  return backend.get(`weborder?${params.toString()}`);
};

export const getWebOrdersByCustomer = (customerId, status) => {
  const params = new URLSearchParams(status.map((x) => ["status", x]));

  return backend.get(`weborder/customer/${customerId}?${params.toString()}`);
};

export const getWebOrderDetails = (webOrderId) => {
  return backend.get(`weborder/${webOrderId}/detail`);
};
export const getWebOrderDiscountsDetails = (webOrderId) => {
  return backend.get(`weborder/${webOrderId}/discountdetail`);
};

export const deleteWebOrder = (webOrderId) => {
  return backend.delete(`weborder/${webOrderId}`);
};

export const getWebOrderCustomerAddresses = (webOrderId) => {
  return backend.get(`weborder/${webOrderId}/customeraddresses`);
};

export const approveWebOrder = (webOrderId) => {
  return backend.get(`weborder/${webOrderId}/approve`);
};

export const getSalesAsigned = (rol, customerId) => {
  return backend.get(`customer/${customerId}/sales/${rol} `)
}
export const getSalesZone = (customerId) => {
  return backend.get(`customer/${customerId}/zone`)
}

export const getSalesClients = (customerId, zone) => {
  return backend.get(`customer/${customerId}/zone/${zone}`)
}

// Transportes (api/transport). Son las formas de envío de GP: el código va siempre en la query
// (lleva espacios, "/" y "."), nunca en el path
export const getTransports = ({ includeInactive = false, includeUnregistered = false } = {}) => {
  const params = new URLSearchParams({ includeInactive, includeUnregistered });
  return backend.get(`transport?${params.toString()}`);
};

export const getTransportDetail = (code) => {
  const params = new URLSearchParams({ code });
  return backend.get(`transport/detail?${params.toString()}`);
};

// La primera vez crea los datos web del transporte
export const updateTransport = (code, transport) => {
  const params = new URLSearchParams({ code });
  return backend.put(`transport?${params.toString()}`, transport);
};

// Alta y edición de una patente: reemplaza todos sus campos, hay que mandar el formulario completo
export const saveTransportPlate = (code, plate) => {
  const params = new URLSearchParams({ code });
  return backend.put(`transport/plate?${params.toString()}`, plate);
};

export const deleteTransportPlate = (code, plate) => {
  const params = new URLSearchParams({ code, plate });
  return backend.delete(`transport/plate?${params.toString()}`);
};

// Planillas de reparto (api/deliverysheet). PUT, cancel y lock/* llevan X-Lock-Id desde el interceptor
// Clientes de GP por número o nombre (CustomerSearchDTO { customerNumber, customerName })
export const searchCustomers = (searchTerm) => {
  return backend.get(`customer/search/${encodeURIComponent(searchTerm)}`);
};

// Facturas y transferencias de inventario candidatas (CandidateDocumentDTO). `customer` es opcional
export const getCandidateDocuments = (from, to, transportCode, customer) => {
  const params = new URLSearchParams({ from, to, transportCode });
  if (customer) params.append("customer", customer);
  return backend.get(`deliverysheet/candidates?${params.toString()}`);
};

export const searchDeliverySheets = (from, to, transportCode, documentNumber) => {
  const params = new URLSearchParams({ from, to });
  if (transportCode) params.append("transportCode", transportCode);
  if (documentNumber) params.append("documentNumber", documentNumber);
  return backend.get(`deliverysheet?${params.toString()}`);
};

export const getDeliverySheet = (sheetId) => {
  return backend.get(`deliverysheet/${sheetId}`);
};

export const createDeliverySheet = (sheet) => {
  return backend.post("deliverysheet", sheet);
};

export const updateDeliverySheet = (sheetId, sheet) => {
  return backend.put(`deliverysheet/${sheetId}`, sheet);
};

export const cancelDeliverySheet = (sheetId) => {
  return backend.post(`deliverysheet/${sheetId}/cancel`);
};

export const printDeliverySheet = (sheetId) => {
  return backend.post(`deliverysheet/${sheetId}/print`, null, { responseType: "blob" });
};

export const acquireDeliverySheetLock = (sheetId) => {
  return backend.post(`deliverysheet/${sheetId}/lock`);
};

export const heartbeatDeliverySheetLock = (sheetId) => {
  return backend.post(`deliverysheet/${sheetId}/lock/heartbeat`);
};

export const releaseDeliverySheetLock = (sheetId) => {
  return backend.post(`deliverysheet/${sheetId}/lock/release`);
};

